module.exports = __webpack_public_path__ + "static/media/Javascript basics card.7221a2ba.svg";